import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { getFileExtension, getFileExtensionFromMimeType } from "#lib/utils/fileMimeType.ts";
import { FileIconAssets } from "#types/assets.ts";
import { useCallback } from "react";

const fileIcons: Record<string, FileIconAssets> = {
    "bmp": FileIconAssets.Bmp,
    "csv": FileIconAssets.Csv,
    "doc": FileIconAssets.Doc,
    "docx": FileIconAssets.Docx,
    "html": FileIconAssets.Html,
    "jpeg": FileIconAssets.Jpg,
    "jpg": FileIconAssets.Jpg,
    "png": FileIconAssets.Png,
    "md": FileIconAssets.Md,
    "pdf": FileIconAssets.Pdf,
    "ppt": FileIconAssets.Ppt,
    "pptx": FileIconAssets.Ppt,
    "tiff": FileIconAssets.Tiff,
    "txt": FileIconAssets.Txt,
    "xls": FileIconAssets.Xls,
    "xlsx": FileIconAssets.Xlsx,
    "xml": FileIconAssets.Xml,
    "heic": FileIconAssets.Image,
    "eml": FileIconAssets.Default,
    "msg": FileIconAssets.Default,
    "p7s": FileIconAssets.Default,
    "epub": FileIconAssets.Default,
    "org": FileIconAssets.Default,
    "odt": FileIconAssets.Default,
    "rst": FileIconAssets.Default,
    "rtf": FileIconAssets.Default,
    "tsv": FileIconAssets.Default
};

export const useFileMetadata = () => {
    const { tShared } = useSharedTranslation();

    const getFileTypeName = useCallback((fileName: string, mediaType?: string): string => {
        const fileExtension = mediaType
            ? getFileExtensionFromMimeType(mediaType) ?? getFileExtension(fileName)
            : getFileExtension(fileName);

        return tShared(`fileTypes.${fileExtension}`, tShared("fileTypes.unknown"));
    }, [tShared]);

    const getFileTypeIcon = useCallback((fileName: string, mediaType?: string) => {
        const fileExtension = mediaType
            ? getFileExtensionFromMimeType(mediaType) ?? getFileExtension(fileName)
            : getFileExtension(fileName);

        return fileIcons[fileExtension] || FileIconAssets.Default;
    }, []);

    return {
        getFileExtension,
        getFileTypeName,
        getFileTypeIcon
    };
};
